import axios from "axios";

export function flagPasteOrDrop(input) {
    ["paste", "drop"].forEach((event) => {
        input.addEventListener(event, (e) => {
            // e.preventDefault(); for now do not prevent input
            flagFraudAttempt(event);
        });
    });
}

const flagFraudAttempt = async (event) => {
    const data = {
        event: event,
    };

    await axios.post(route("fraud-detection.flag.user"), data);
};
